import { render, staticRenderFns } from "./CalculationsPanel.vue?vue&type=template&id=20981864&scoped=true"
import script from "./CalculationsPanel.vue?vue&type=script&lang=js"
export * from "./CalculationsPanel.vue?vue&type=script&lang=js"
import style0 from "./CalculationsPanel.vue?vue&type=style&index=0&id=20981864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20981864",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VDataFooter,VDataTable})
